// EditarMultimedia.jsx
import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

function EditarMultimedia(props) {
	const { multimedia, guardar, setQueMostrar } = props
	const [datos, setDatos] = useState({})
	const [preview, setPreview] = useState(null)

	useEffect(() => {
		setDatos({
			id: multimedia.id,
			descripcion: multimedia.descripcion,
			orden: multimedia.orden,
			files: []
		})
	}, [multimedia])

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
		setPreview(null)
	}

	const handleProcesar = (e) => {
		e.preventDefault()
		guardar(datos)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const updateArchivo = (files) => {
		if (files.length > 0) {
			const datosCopia = { ...datos }
			datosCopia.files = files
			setDatos(prev => datosCopia)

			// Crear preview
			const reader = new FileReader()
			reader.onloadend = () => {
				setPreview(reader.result)
			}
			reader.readAsDataURL(files[0])
		} else {
			const datosCopia = { ...datos }
			datosCopia.files = []
			setDatos(prev => datosCopia)
			setPreview(null)
		}
	}

	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar multimedia" />
			<Offcanvas.Body>
				<h1>Datos del archivo multimedia</h1>
				{datos.id && (
					<Row>
						<Col sm={12} md={6}>
							<Form onSubmit={handleProcesar} className="ms-4">
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="multimedia-descripcion">
											<FormLabel>Descripción</FormLabel>
											<Form.Control
												value={datos.descripcion}
												type="text"
												onChange={(e) => handleChange(e.target.value, 'descripcion')}
												required
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3 col-md-3" controlId="multimedia-orden">
											<FormLabel>Orden</FormLabel>
											<Form.Control
												value={datos.orden}
												type="number"
												onChange={(e) => handleChange(e.target.value, 'orden')}
												required
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="multimedia-actual mb-4">
											<h4>Archivo actual</h4>
											<img
												src={process.env.REACT_APP_API_URL + 'uploads/' + multimedia.url}
												alt={multimedia.descripcion}
												className="img-fluid"
											/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<FileUpload
											updateFiles={updateArchivo}
											title="Cambiar archivo"
											accept="image/*"
										/>
									</Col>
								</Row>
								{preview && (
									<Row className="mt-3">
										<Col>
											<h4>Nuevo archivo</h4>
											<img
												src={preview}
												alt="Vista previa"
												className="img-fluid"
											/>
										</Col>
									</Row>
								)}
							</Form>
						</Col>
					</Row>
				)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarMultimedia